import { render, staticRenderFns } from "./AddNewWorkModal.vue?vue&type=template&id=e597fc32"
import script from "./AddNewWorkModal.vue?vue&type=script&lang=js"
export * from "./AddNewWorkModal.vue?vue&type=script&lang=js"
import style0 from "./AddNewWorkModal.vue?vue&type=style&index=0&id=e597fc32&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports